import React from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { useEffect } from 'react';
import { useRef } from 'react';

function App({ textModal, titleModal, setModal, imageModal}) {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setModal]);


  return (
    <>
        <div className="modal-box">
            <div ref={modalRef}>
                <button onClick={() => setModal(false)}><span>Zavřít</span></button>
                <div className="image-modal-blocker">
                    <img src={imageModal} alt="Bike" />
                </div>
                <h1>{titleModal}</h1>
                <p>{textModal}</p>
            </div>
        </div>
    </>
  );
}

export default App;
